<article>
  <sd-push-card
    [brand]="brand ? brand : pushFullHeight?.brand"
    [indexFollow]="pushFullHeight?.indexFollow !== undefined ? pushFullHeight?.indexFollow : true"
    [isLoading]="isLoading"
    [textConfig]="pushFullHeight?.textConfig"
    [mediaAsBackground]="true"
    [push]="pushFullHeight?.push"
    [titleLevel]="titleLevel"
    [pushSize]="pushSizeEnum.m"
    (clicked)="onClick($event, pushFullHeight.push)"
    (videoEnded)="onVideoEnded(pushFullHeight)"
    (videoPlayed)="onVideoPlayed(pushFullHeight)"
    [themesConfig]="pushFullHeight?.themesConfig"
    [twicPicsAutoSize]="twicPicsAutoSize"
    (cardClicked)="onCardClick(pushFullHeight.push)"
  />
</article>

<div class="c__pushs">
  <article>
    <sd-push-card
      [brand]="brand ? brand : pushTop?.brand"
      [indexFollow]="pushTop?.indexFollow !== undefined ? pushTop?.indexFollow : true"
      [isLoading]="isLoading"
      [textConfig]="pushTop?.textConfig"
      [mediaAsBackground]="true"
      [push]="pushTop?.push"
      [titleLevel]="titleLevel"
      [pushSize]="pushSizeEnum.m"
      (clicked)="onClick($event, pushTop.push)"
      (videoEnded)="onVideoEnded(pushTop)"
      (videoPlayed)="onVideoPlayed(pushTop)"
      [themesConfig]="pushTop?.themesConfig"
      [twicPicsAutoSize]="twicPicsAutoSize"
      (cardClicked)="onCardClick(pushTop.push)"
    />
  </article>

  <article>
    <sd-push-card
      [brand]="brand ? brand : pushBottom?.brand"
      [indexFollow]="pushBottom?.indexFollow !== undefined ? pushBottom?.indexFollow : true"
      [isLoading]="isLoading"
      [textConfig]="pushBottom?.textConfig"
      [mediaAsBackground]="true"
      [push]="pushBottom?.push"
      [titleLevel]="titleLevel"
      [pushSize]="pushSizeEnum.m"
      (clicked)="onClick($event, pushBottom.push)"
      (videoEnded)="onVideoEnded(pushBottom)"
      (videoPlayed)="onVideoPlayed(pushBottom)"
      [themesConfig]="pushBottom?.themesConfig"
      [twicPicsAutoSize]="twicPicsAutoSize"
      (cardClicked)="onCardClick(pushBottom.push)"
    />
  </article>
</div>
